import FormSection from './FormSection'
import { translations } from '../../data/translations'

const SupportSection = ({ formData, updateFormData, language }) => {
  const t = translations[language]?.support || translations.de.support

  const handleCheckboxChange = (field, value) => {
    const currentValues = formData[field] || []
    const newValues = currentValues.includes(value)
      ? currentValues.filter(v => v !== value)
      : [...currentValues, value]
    updateFormData(field, newValues)
  }

  return (
    <FormSection
      title={t.title}
      subtitle={t.subtitle}
    >
      {/* 14.1 Support-Leistungen */}
      <div className="subsection">
        <div className="subsection-title">{t.subtitle1}</div>
        
        <div className="checkbox-group" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))' }}>
          {t.supportLeistungenOptionen.map(option => (
            <div key={option.value} className="checkbox-item">
              <input
                type="checkbox"
                id={`sup-${option.value}`}
                checked={(formData.support_leistungen || []).includes(option.value)}
                onChange={() => handleCheckboxChange('support_leistungen', option.value)}
              />
              <label htmlFor={`sup-${option.value}`}>{option.label}</label>
            </div>
          ))}
        </div>
      </div>

      {/* 14.2 Support-Modell */}
      <div className="subsection">
        <div className="subsection-title">{t.subtitle2}</div>
        
        <div className="form-group">
          <label>{t.supportModell}</label>
          <div className="radio-group">
            {t.supportModellOptionen.map(option => (
              <div key={option.value} className="radio-item">
                <input
                  type="radio"
                  id={`sup-mod-${option.value}`}
                  name="support_modell"
                  value={option.value}
                  checked={formData.support_modell === option.value}
                  onChange={(e) => updateFormData('support_modell', e.target.value)}
                />
                <label htmlFor={`sup-mod-${option.value}`}>{option.label}</label>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* 14.3 Übergabe & Dokumentation */}
      <div className="subsection">
        <div className="subsection-title">{t.subtitle3}</div>
        
        <div className="checkbox-group" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))' }}>
          {t.uebergabeOptionen.map(option => (
            <div key={option.value} className="checkbox-item">
              <input
                type="checkbox"
                id={`ueb-${option.value}`}
                checked={(formData.uebergabe || []).includes(option.value)}
                onChange={() => handleCheckboxChange('uebergabe', option.value)}
              />
              <label htmlFor={`ueb-${option.value}`}>{option.label}</label>
            </div>
          ))}
        </div>
      </div>
    </FormSection>
  )
}

export default SupportSection
